import React, { Component } from "react";
import { Tabs, Tab, Button } from "react-bootstrap";
import { File, Search, Info } from "react-feather";
import { Link } from "react-router-dom";
import Dashboard from "./Dashboard";
import TrackerList from "./../Tracker/TrackerList";
import CapaList from "./../Tracker/CapaList";
import NmList from "./../NmList/NmList";
import ArchiveList from "./../Archive/ArchiveList";
import Url from "app/shared/constants/Url";
import axios from "axios";
import Workbook from "react-excel-workbook";
import { CHANGE_TAB } from "app/redux/constant/ActionType";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel } from "@fortawesome/free-regular-svg-icons";
import InfoComponent from "app/shared/utility/InfoComponent";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import LoadingImage from "app/shared/components/Loader/LoadingImage";
//component
import NMModuleV2 from "../container";
const qs = require("qs");

const mapStateToProps = (state) => {
  const data = { ...state.nm.nm };
  return {
    service_id: data.service_id,
    project_id: data.project_id,
    service_name: data.service_name,
    project_name: data.project_name,
    start_date: data.start_date,
    end_date: data.end_date,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeTab: (tabName) => {
      dispatch({ type: CHANGE_TAB, payload: tabName });
    },
  };
};

class NmDashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dataLoading: true,
      currentPage: 1,
      currentPageProgress: 1,
      currentPageCompleted: 1,
      progress_list: [],
      completed_list: [],
      nmHeaderCount: [],
      tracker_list: [],
      nmCompletedl: [],
      nmCompletedl_archive: [],
      nmPendingl: [],
      nmPendingl_archive: [],
      nmProgressl: [],
      nmProgressl_archive: [],
      progress_list2: [],
      progress_list2_archive: [],
      completed_list2: [],
      completed_list2_archive: [],
      nmCompleted2: [],
      nmCompleted2_archive: [],
      nmPending2: [],
      nmPending2_archive: [],
      nmProgress2: [],
      nmProgress2_archive: [],
      openListRefreshing: false,
      userFlag: "",
      totalCount: 0,
      perPage: 10,
      hasMore: false,
      moreDataLoading: false,
      trackLi: {},
      active: "dashboard",
      trackerexport: [],
      searchList: "",
      searchList2: "",
      searchList3: "",
      startDate: new Date(),
      endDate: new Date(),
      pageNumber: 1,
      pageNumberCompleted: 1,
      overdue: 0,
      service: [],
      serviceSelect: "",
      project: [],
      projectSelect: "",
      R_person: [],
      extremeSelect: 0,
      extremeValue: 0,
      highSelect: 0,
      mediumSelect: 0,
      lowSelect: 0,
      all: 0,
      allValue: [],
      allS: [],
      severity: [],
      personSelect: [],
      CategoryFilter: [],
      isFirstFetching: false,
      capaInprogressList: [],
      capaCompletedList: [],
      capaOrignalInprogressList: [],
      capaOriganlCompletedList: [],
      capaCompletedCount: 0,
      totalCapaCount: 0,
      originFrom: this.props.match.params.type,
      nmPendingOrignalList: [],
      nmPendingOrignalList_archive: [],
      nmProgressOrignalList: [],
      nmProgressOrignalList_archive: [],
      nmCompletedOrignalList: [],
      nmCompletedOrignalList_archive: [],
      nmPendingPageNo: 1,
      nmProgressPageNo: 1,
      nmCompletedPageNo: 1,
      nmProgressFilterPageNo: 1,
      nmCompleteFilterPageNo: 1,
      nmPendingFilterPageNo: 1,
      pendingFilterCount: 0,
      inprogressFilterCount: 0,
      completeFilterCount: 0,
    };
    // this._getnmHeaderCount();

    this.child = React.createRef();
  }

  componentDidMount() {
    this._getnmHeaderCount();
    this._getNMList(1, "PROJECT");
    this._getNMListArchive(1, "PROJECT");
    this._getNMProgressList(1, "PROJECT");
    this._getNMProgressListArchive(1, "PROJECT");
    this._getNMCompletedList(1, "PROJECT");
    this._getNMCompletedListArchive(1, "PROJECT");
    // this.nmTrackerList(1, "ALL");
    this.nmInprogressTrackerList(1, "PROJECT");
    this.nmTrackerCompletedList(1, "PROJECT");
    this._getTrackerListExport();
    this._getNMListExport();
    this.activeSP = this.activeSP.bind(this);
    // this._getNMProgressList(1);

    this._handleInputChange2 = async (event) => {
      const val = event.target.value;

      await this.setState((prevState) => {
        let { searchList2, searchBtnClicked2, progress_list, progress_list2 } =
          prevState;
        searchList2 = val;
        searchBtnClicked2 = true;
        progress_list = (progress_list2 || []).filter((data) => {
          if (!data) return false;
          const search = searchList2 ? searchList2.toLowerCase() : "";
          return (
            data.category?.toLowerCase().includes(search) ||
            data.activity?.toLowerCase().includes(search) ||
            data.service?.toLowerCase().includes(search) ||
            data.project?.toLowerCase().includes(search) ||
            data.recommendedby?.toLowerCase().includes(search) ||
            data.type_of_Act?.toLowerCase().includes(search) ||
            data.type_of_act?.toLowerCase().includes(search)
          );
        });
        return { searchList2, searchBtnClicked2, progress_list };
      });
      if (!val || val === "") {
        await this.nmTrackerList(1);
      }
    };
    this._handleInputChange3 = async (event) => {
      const val = event.target.value;

      if (!val || val === "") {
        await this.nmTrackerCompletedList(1);
      }
      await this.setState((prevState) => {
        let {
          searchList3,
          searchBtnClicked3,
          completed_list,
          completed_list2,
        } = prevState;
        searchList3 = val;
        searchBtnClicked3 = true;
        completed_list = (completed_list2 || []).filter((data) => {
          if (!data) return false;
          const search = searchList3 ? searchList3.toLowerCase() : "";
          return (
            data.category?.toLowerCase().includes(search) ||
            data.activity?.toLowerCase().includes(search) ||
            data.service?.toLowerCase().includes(search) ||
            data.project?.toLowerCase().includes(search) ||
            data.recommendedby?.toLowerCase().includes(search) ||
            data.type_of_Act?.toLowerCase().includes(search) ||
            data.type_of_act?.toLowerCase().includes(search)
          );
        });
        return { searchList3, searchBtnClicked3, completed_list };
      });
    };
    this.setState({ isFirstFetching: true });
  }

  _textIncludeCheck = (sourceText = "", searchText = "") => {
    if (!sourceText) return false;
    return String(sourceText).toLowerCase().includes(searchText);
  };

  _handleInputChange = async (event) => {
    const val = event.target.value;

    if (val.trim() == "") {
      await this.setState({
        searchList: val,
        searchBtnClicked: true,
        capaInprogressList: this.state.capaOrignalInprogressList,
        capaCompletedList: this.state.capaOriganlCompletedList,
      });
    } else {
      await this.setState((prevState) => {
        let {
          searchList,
          searchBtnClicked,
          capaCompletedList,
          capaInprogressList,
          capaOriganlCompletedList,
          capaOrignalInprogressList,
        } = prevState;

        searchList = val;
        searchBtnClicked = true;
        let searchTerm = searchList.toLowerCase();

        capaInprogressList = capaOrignalInprogressList.filter((data) => {
          if (this._textIncludeCheck(data.activity, searchTerm)) {
            return data;
          } else if (this._textIncludeCheck(data.service, searchTerm)) {
            return data;
          } else if (this._textIncludeCheck(data.project, searchTerm)) {
            return data;
          } else if (
            data.list.some((item) =>
              this._textIncludeCheck(item.recommendedby, searchTerm)
            )
          ) {
            return data;
          } else if (
            data.list.some((item) =>
              this._textIncludeCheck(item.category, searchTerm)
            )
          ) {
            return data;
          } else if (
            data.list.some((item) =>
              this._textIncludeCheck(item.type_of_Act, searchTerm)
            )
          ) {
            return data;
          }
        });

        capaCompletedList = capaOriganlCompletedList.filter((data) => {
          if (this._textIncludeCheck(data.activity, searchTerm)) {
            return data;
          } else if (this._textIncludeCheck(data.service, searchTerm)) {
            return data;
          } else if (this._textIncludeCheck(data.project, searchTerm)) {
            return data;
          } else if (
            data.list.some((item) =>
              this._textIncludeCheck(item.recommendedby, searchTerm)
            )
          ) {
            return data;
          } else if (
            data.list.some((item) =>
              this._textIncludeCheck(item.category, searchTerm)
            )
          ) {
            return data;
          } else if (
            data.list.some((item) =>
              this._textIncludeCheck(item.type_of_Act, searchTerm)
            )
          ) {
            return data;
          }
        });

        return {
          searchList,
          searchBtnClicked,
          capaCompletedList,
          capaInprogressList,
        };
      });
    }
  };

  _getnmHeaderCount = async (type = "PROJECT") => {
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("token");
    let data;
    data = new FormData();

    if (type == "PROJECT") {
      if (this.state.project_id && this.state.project_id.length > 0) {
        this.state.project_id.forEach((item) => {
          data.append("projectId", item);
        });
      }
    }

    data.append("auth_key", token);
    data.append("user_id", userId);
    data.append("startDate", this.props.start_date);
    data.append("endDate", this.props.end_date);
    let URL = Url.nmModule.nmHeaderCount;
    let headerType = "multipart/form-data";
    await axios
      .post(URL, data, {
        headers: {
          "Content-Type": headerType,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          this.setState({ nmHeaderCount: response.data.data });
        } else {
        }
      })
      .catch((error) => {
        throw error;
      });
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      nextProps.project_id !== prevState.project_id ||
      nextProps.service_id !== prevState.service_id ||
      nextProps.start_date != prevState.start_date ||
      nextProps.end_date != prevState.end_date
    ) {
      return {
        service_id: nextProps.service_id,
        project_id: nextProps.project_id,
        start_date: nextProps.start_date,
        end_date: nextProps.end_date,
      };
    }
    return null;
  }

  async componentDidUpdate(prevProps, prevState) {
    if (
      this.props.service_id !== prevProps.service_id ||
      this.props.project_id !== prevProps.project_id ||
      this.props.start_date != prevProps.start_date ||
      this.props.end_date != prevProps.end_date
    ) {
      if (this.state.isFirstFetching) {
        this.setState({
          dataLoading: true,
          nmCompletedl: [],
          nmCompletedl_archive: [],
          nmPendingl: [],
          nmPendingl_archive: [],
          nmProgressl: [],
          nmProgressl_arcive: [],
          progress_list2: [],
          progress_list2_archive: [],
          completed_list2: [],
          completed_list2_archive: [],
          nmCompleted2: [],
          nmCompleted2_archive: [],
          capaInprogressList: [],
          capaCompletedList: [],
          nmPending2: [],
          nmPending2_archive: [],
          nmProgress2: [],
          nmProgress2_archive: [],
          progress_list: [],
          completed_list: [],
        }, async () => {
          await this._getnmHeaderCount();
          await this.nmInprogressTrackerList(1);
          await this.nmTrackerCompletedList(1);
          await this._getNMList(1);
          await this._getNMListArchive(1)
          await this._getNMProgressList(1);
          await this._getNMProgressListArchive(1);
          await this._getNMCompletedList(1);
          await this._getNMCompletedListArchive(1);
          await this._getTrackerListExport();
          await this._getNMListExport();
        });

      } else {
        await this.setState({ isFirstFetching: true });
      }
    }
  }

  _handleFilterReset = async (type = "pending") => {
    // await this.nmTrackerList(1, "ALL");
    if (type == "pending") {
      this._handlePendingFilterReset();
    } else if (type == "progress") {
      this._handleProgressFilterReset();
    } else if (type == "completed") {
      this._handleCompletedFilterReset();
    }
  };

  _handlePendingFilterReset = async () => {
    try {
      await this.setState((prevState) => {
        let { nmPendingl, nmPending2, nmPendingOrignalList } = prevState;
        nmPendingl = [...nmPendingOrignalList];
        nmPending2 = [...nmPendingOrignalList];

        return {
          nmPendingl,

          nmPending2,
        };
      });
      // await this._getNMList(1, "ALL");
    } catch (error) { }
  };

  _handleProgressFilterReset = async () => {
    try {
      await this.setState((prevState) => {
        let {
          nmProgressl,
          progress_list2,
          progress_list,
          nmProgress2,
          nmProgressOrignalList,
        } = prevState;

        nmProgress2 = [...nmProgressOrignalList];
        nmProgressl = [...nmProgressOrignalList];
        progress_list2 = [...nmProgressOrignalList];
        progress_list = [...nmProgressOrignalList];

        return {
          nmProgressl,
          progress_list,
          nmProgress2,
          progress_list2,
        };
      });
      // await this._getNMProgressList(1, "ALL");
    } catch (error) { }
  };

  _handleCompletedFilterReset = async () => {
    try {
      await this.setState((prevState) => {
        let {
          nmCompletedl,
          completed_list2,
          nmCompleted2,
          completed_list,
          nmCompletedOrignalList,
        } = prevState;

        nmCompleted2 = [...nmCompletedOrignalList];
        nmCompleted2 = [...nmCompletedOrignalList];
        nmCompletedl = [...nmCompletedOrignalList];
        completed_list2 = [...nmCompletedOrignalList];
        completed_list = [...nmCompletedOrignalList];

        return {
          nmCompletedl,
          completed_list2,
          nmCompleted2,
          completed_list,
        };
      });
      // await this.nmTrackerCompletedList(1, "ALL");
      // await this._getNMCompletedList(1, "ALL");
    } catch (error) { }
  };

  nmInprogressTrackerList = async (value, type = "PROJECT") => {
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("springToken");
    if (value > this.state.lastPageInprogress && value != 1) return;

    await this.setState({ pageNumber: value });
    let data;
    data = new FormData();
    if (type == "PROJECT") {
      if (this.state.project_id && this.state.project_id.length > 0) {
        this.state.project_id.forEach((item) => {
          data.append("project_id", item);
        });
      }
    }

    data.append("page_no", value);
    data.append("auth_key", token);
    data.append("user_id", userId);
    data.append("start_date", this.props.start_date);
    data.append("end_date", this.props.end_date);
    data.append("type", 1);
    let URL = Url.nmModule.springNmTracker;
    let headerType = "multipart/form-data";
    await axios
      .post(URL, data, {
        headers: {
          "Content-Type": headerType,
        },
      })
      .then(async (response) => {
        if (response.data.status === 200) {
          // tracker data
          const {
            completed_tracker_list,
            inprogress_tracker_list,
            completed_number,
            inprogress_number,
            totalInprogress_cardCounts,
            totalCompleted_cardCounts,
            total_cardCounts,
            total_number,
            total_inprogressCapaCount
          } = response?.data?.data;

          await this.setState((prevState) => {
            let {
              capaInprogressList,
              capaOrignalInprogressList,
              // capaProgressCount,
              totalCapaCount,
            } = prevState;

            // capaInprogressList = inprogress_tracker_list;

            // capaOrignalInprogressList = inprogress_tracker_list;

            // capaProgressCount = inprogress_number;
            // capaProgressCount = this.state.capaProgressCount + inprogress_number;
            totalCapaCount = total_cardCounts;

            return {
              capaInprogressList,
              // pageNumber: value,
              totalCapaCount,
              capaOrignalInprogressList,
              totalInprogress_cardCounts,
              totalCapaCount: total_number
            };
          });

          this.setState({
            nmtrackListRefreshing: false,
            nmtrackListLoading: false,
            totalCount: this.state.nmHeaderCount.tracker_number,
            lastPageInprogress: Math.ceil(totalInprogress_cardCounts / 10),
            currentPageProgress: this.state.currentPageProgress + 1,
            moreDataLoading: false,
          });

          this.setState({ CategoryFilter: response.data.data.tracker_list });
          if (this.state.capaInprogressList.length == 0 || value == 1) {
            this.setState({
              // inprogress_number: response.data.data.inprogress_number,
              capaProgressCount: inprogress_number,
              capaCompletedCount: totalCompleted_cardCounts,
              totalCountracker: response.data.data.total_number,
              totalCapaCount: total_number,
            });
            this.setState({
              capaInprogressList: inprogress_tracker_list,
              capaOrignalInprogressList: inprogress_tracker_list,
            });
          } else {
            this.setState({
              capaProgressCount: totalInprogress_cardCounts,
              capaCompletedCount: totalCompleted_cardCounts,
              capaInprogressList: [
                ...this.state.capaInprogressList,
                ...inprogress_tracker_list,
              ],

              totalCapaCount: total_number
            });
            this.setState({
              capaOrignalInprogressList: [
                ...this.state.capaOrignalInprogressList,
                ...inprogress_tracker_list,
              ],
              totalCapaCount: total_number,
            });
          }
          inprogress_tracker_list.map((data) =>
            this.setState({ R_person: data.tracking_responsible_person })
          );
        } else {
          this.setState({ dataLoading: false });
        }
      })
      .catch((error) => {
        this.setState({ dataLoading: false });
      });
  };

  nmTrackerCompletedList = async (value, type = "PROJECT") => {
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("springToken");
    if (value > this.state.lastPageCompleted && value != 1) return;
    await this.setState({ pageNumberCompleted: value });

    let data;
    data = new FormData();

    if (type == "PROJECT") {
      if (this.state.project_id && this.state.project_id.length > 0) {
        this.state.project_id.forEach((item) => {
          data.append("project_id", item);
        });
      }
    }

    data.append("page_no", value);
    data.append("auth_key", token);
    data.append("user_id", userId);
    data.append("start_date", this.props.start_date);
    data.append("end_date", this.props.end_date);
    data.append("type", 2);
    let URL = Url.nmModule.springNmTracker;
    let headerType = "multipart/form-data";
    await axios
      .post(URL, data, {
        headers: {
          "Content-Type": headerType,
        },
      })
      .then((response) => {
        if (response.data.status === 200) {
          const {
            completed_tracker_list,
            totalCompleted_cardCounts,
            total_number,
          } = response?.data?.data;

          this.setState({
            nmtrackListRefreshing: false,
            nmtrackListLoading: false,
            totalCount: this.state.nmHeaderCount.tracker_number,
            lastPageCompleted: Math.ceil(totalCompleted_cardCounts / 10),
            hasMore:
              this.state.currentPageProgress <=
              Math.ceil(this.state.nmHeaderCount.tracker_number / 10),
            currentPageProgress: this.state.currentPageProgress + 1,
            moreDataLoading: false,
          });

          if (this.state.capaCompletedList.length == 0 || value == 1) {
            this.setState({
              capaCompletedCount: totalCompleted_cardCounts,
              capaCompletedList: [],
            });
            this.setState({
              capaCompletedList: completed_tracker_list,
              capaOriganlCompletedList: completed_tracker_list,
            });
          } else {
            this.setState({
              // capaCompletedCount: completed_number,

              capaCompletedCount: totalCompleted_cardCounts,
              capaCompletedList: [
                ...this.state.capaCompletedList,
                ...completed_tracker_list,
              ],
              capaOriganlCompletedList: [
                ...this.state.capaOriganlCompletedList,
                ...completed_tracker_list,
              ],
              totalCapaCount:
                total_number,
            });
          }
        }

        this.setState({ dataLoading: false });
      })
      .catch((error) => {
        this.setState({ dataLoading: false });
      });
  };

  nmTrackerListFilterProgress = async (
    severity,
    overdue,
    serviceSelect,
    projectSelect,
    categorySelect,
    startDate,
    endDate,
    personSelect,
    statusCheck
  ) => {
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("token");
    await axios
      .post(
        Url.nmModule.trackerfilter,
        qs.stringify(
          {
            auth_key: token,
            user_id: userId,
            page_no: this.state.currentPage,
            severity: severity,
            overdue: overdue,
            service_id: serviceSelect,
            project_id: projectSelect,
            category: categorySelect,
            start_date: new Date(startDate).toISOString().slice(0, 10),
            end_date: new Date(endDate).toISOString().slice(0, 10),
            responsible_person_id: personSelect,
            status: statusCheck,
          },
          { arrayFormat: "repeat" }
        ),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      )
      .then((response) => {
        if (response.data.status === 200) {
          this.setState({
            nmtrackListRefreshing: false,
            nmtrackListLoading: false,
            totalCount: this.state.nmHeaderCount.tracker_number,
            lastPage: Math.ceil(this.state.nmHeaderCount.tracker_number / 10),
            hasMore:
              this.state.currentPage <=
              Math.ceil(this.state.nmHeaderCount.tracker_number / 10),
            currentPage: this.state.currentPage + 1,
            moreDataLoading: false,
          });

          if (this.state.progress_list.length == 0) {
            // this.setState({inprogress_number: response.data.data.inprogress_number})
            this.setState({ progress_list: [] });
            this.setState({
              progress_list: response.data.data.tracker_list,
              dataLoading: false,
            });
          } else {
            // this.setState({inprogress_number: response.data.data.inprogress_number})
            this.setState({
              progress_list: [...response.data.data.tracker_list],
              dataLoading: false,
            });
          }
          this.child.current.resetStates();
        }
        this.setState({ dataLoading: false });
      })
      .catch((error) => {
        this.setState({ dataLoading: false });
      });
  };

  nmTrackerListFilterCompleted = async (
    severity,
    overdue,
    serviceSelect,
    projectSelect,
    categorySelect,
    startDate,
    endDate,
    personSelect,
    statusCheck
  ) => {
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("token");

    await axios
      .post(
        Url.nmModule.trackerfilter,
        qs.stringify(
          {
            auth_key: token,
            user_id: userId,
            page_no: this.state.currentPage,
            severity: severity,
            overdue: overdue,
            service_id: serviceSelect,
            project_id: projectSelect,
            category: categorySelect,
            start_date: new Date(startDate).toISOString().slice(0, 10),
            end_date: new Date(endDate).toISOString().slice(0, 10),
            responsible_person_id: personSelect,
            status: statusCheck,
          },
          { arrayFormat: "repeat" }
        ),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      )
      .then((response) => {
        if (response.data.status === 200) {
          this.setState({
            nmtrackListRefreshing: false,
            nmtrackListLoading: false,
            totalCount: this.state.nmHeaderCount.tracker_number,
            lastPage: Math.ceil(this.state.nmHeaderCount.tracker_number / 10),
            hasMore:
              this.state.currentPage <=
              Math.ceil(this.state.nmHeaderCount.tracker_number / 10),
            currentPage: this.state.currentPage + 1,
            moreDataLoading: false,
          });

          if (this.state.completed_list.length == 0) {
            // this.setState({completed_number: response.data.data.completed_number})
            this.setState({ completed_list: [] });
            this.setState({
              completed_list: response.data.data.tracker_list,
              dataLoading: false,
            });
          } else {
            // this.setState({completed_number: response.data.data.completed_number})
            this.setState({
              completed_list: [...response.data.data.tracker_list],
              dataLoading: false,
            });
          }
          this.child.current.resetStates();
        }
        this.setState({ dataLoading: false });
      })
      .catch((error) => {
        this.setState({ dataLoading: false });
      });
  };

  _getTrackerListExport = async (type = "PROJECT") => {
    this.setState({ moreDataLoading: true });
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("token");

    let data;
    data = new FormData();
    if (type == "PROJECT") {
      if (this.state.project_id && this.state.project_id.length > 0) {
        this.state.project_id.forEach((item) => {
          data.append("project_id", item);
        });
      }
    }
    data.append("auth_key", token);
    data.append("user_id", userId);
    let URL = Url.nmModule.nmtrackerlistexport;
    let headerType = "multipart/form-data";
    await axios
      .post(URL, data, {
        headers: {
          "Content-Type": headerType,
        },
      })
      .then((response) => {
        if (response.data.status == 200) {
          this.setState({
            trackerexport: response.data.data.tracker_list,
            dataLoading: false,
          });
        }
      })
      .catch((error) => { });
  };
  activeSP = (eventKey) => {
    this.setState({ active: eventKey });
  };
  // end tracker

  //Archive NM List
  _getNMListArchive = async (value = 1, type = "PROJECT") => {
    this.setState({ moreDataLoading: true });
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("springToken");
    if (value > this.state.lastPagePending && value !== 1) return;
    await this.setState({ nmPendingPageNo: value });
    let data = new FormData();

    if (type === "PROJECT") {
      if (this.state.project_id && this.state.project_id.length > 0) {
        this.state.project_id.forEach((item) => {
          data.append("projectIdList", item);
        });
      }
    }
    data.append("page", Math.ceil(value));
    data.append("auth_key", token);
    data.append("user_id", userId);
    data.append("startDate", this.props.start_date);
    data.append("endDate", this.props.end_date);
    data.append("type", 0);

    let URL = Url.nmModule.nmList;
    let headerType = "multipart/form-data";
    await axios
      .post(URL, data, {
        headers: {
          "Content-Type": headerType,
        },
        params: {
          auth_key: token,
          user_id: userId,
          softDelete: 1, // <--- ARCHIVE PARAM
        }
      })
      .then((response) => {
        if (response.data.status === 200) {
          if (this.state.nmPendingl.length === 0 || value === 1) {
            this.setState({
              total_pendingnm_archive: response.data.data.total_pendingnm,
              nmPendingl_archive: response.data.data.pendingnm.nm_basic_info,
              nmPending2_archive: response.data.data.pendingnm.nm_basic_info,
              nmPendingOrignalList_archive: response.data.data.pendingnm.nm_basic_info,
              lastPagePending: Math.ceil(response.data.data.total_pendingnm / 10),
            });
          } else {
            this.setState({
              nmPendingl_archive: [
                ...this.state.nmPendingl_archive,
                ...response.data.data.pendingnm.nm_basic_info,
              ],
              nmPending2: [
                ...this.state.nmPending2_archive,
                ...response.data.data.pendingnm.nm_basic_info,
              ],
            });
          }
        }
      })
      .catch((error) => { })
      .finally(() =>
        this.setState({
          dataLoading: false,
        })
      );
  };

  _getNMProgressListArchive = async (value = 1, type = "PROJECT") => {
    this.setState({ moreDataLoading: true });
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("springToken");
    if (value > this.state.lastPageProgress && value !== 1) return;
    await this.setState({ nmProgressPageNo: value });
    let data = new FormData();

    if (type === "PROJECT") {
      if (this.state.project_id && this.state.project_id.length > 0) {
        this.state.project_id.forEach((item) => {
          data.append("projectIdList", item);
        });
      }
    }
    data.append("page", Math.ceil(value));
    data.append("auth_key", token);
    data.append("user_id", userId);
    data.append("startDate", this.props.start_date);
    data.append("endDate", this.props.end_date);
    data.append("type", 1);

    let URL = Url.nmModule.nmList;
    let headerType = "multipart/form-data";
    await axios
      .post(URL, data, {
        headers: {
          "Content-Type": headerType,
        },
        params: {
          auth_key: token,
          user_id: userId,
          softDelete: 1, // <--- ARCHIVE PARAM
        }
      })
      .then((response) => {
        if (response.data.status === 200) {
          if (this.state.nmProgressl.length === 0 || value === 1) {
            this.setState({
              total_inprogressnm_archive: response.data.data.total_inprogressnm,
              nmProgressl_archive: response.data.data.inprogressnm.nm_basic_info,
              nmProgress2_archive: response.data.data.inprogressnm.nm_basic_info,
              nmProgressOrignalList_archive: response.data.data.inprogressnm.nm_basic_info,
              lastPageProgress: Math.ceil(response.data.data.total_inprogressnm / 10),
            });
          } else {
            this.setState({
              nmProgressl_archive: [
                ...this.state.nmProgressl_archive,
                ...response.data.data.inprogressnm.nm_basic_info,
              ],
              nmProgress2_archive: [
                ...this.state.nmProgress2_archive,
                ...response.data.data.inprogressnm.nm_basic_info,
              ],
              nmProgressOrignalList_archive: [
                ...this.state.nmProgressOrignalList_archive,
                ...response.data.data.inprogressnm.nm_basic_info,
              ],
            });
          }
        }
        this.setState({ dataLoading: false });
      })
      .catch((error) => {
        this.setState({ dataLoading: false });
      });
  };

  _getNMCompletedListArchive = async (value = 1, type = "PROJECT") => {
    this.setState({ moreDataLoading: true });
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("springToken");
    if (value > this.state.lastPageCompleted_archive && value !== 1) return;
    await this.setState({ nmCompletedPageNo: value });
    let data = new FormData();

    if (type === "PROJECT") {
      if (this.state.project_id && this.state.project_id.length > 0) {
        this.state.project_id.forEach((item) => {
          data.append("projectIdList", item);
        });
      }
    }
    data.append("page", Math.ceil(value));
    data.append("auth_key", token);
    data.append("user_id", userId);
    data.append("startDate", this.props.start_date);
    data.append("endDate", this.props.end_date);
    data.append("type", 2);

    let URL = Url.nmModule.nmList;
    let headerType = "multipart/form-data";
    await axios
      .post(URL, data, {
        headers: {
          "Content-Type": headerType,
        },
        params: {
          auth_key: token,
          user_id: userId,
          softDelete: 1, // <--- ARCHIVE PARAM
        }
      })
      .then((response) => {
        if (response.data.status === 200) {
          if (this.state.nmCompletedl.length === 0 || value === 1) {
            this.setState({
              total_completednm_archive: response.data.data.total_completednm,
              nmCompletedl_archive: response.data.data.completednm.nm_basic_info,
              nmCompleted2_archive: response.data.data.completednm.nm_basic_info,
              nmCompletedOrignalList_archive: response.data.data.completednm.nm_basic_info,
              lastPageCompleted_archive: Math.ceil(response.data.data.total_completednm / 10),
            });
          } else {
            this.setState({
              nmCompletedl_archive: [
                ...this.state.nmCompletedl_archive,
                ...response.data.data.completednm.nm_basic_info,
              ],
              nmCompleted2_archive: [
                ...this.state.nmCompleted2_archive,
                ...response.data.data.completednm.nm_basic_info,
              ],
              nmCompletedOrignalList_archive: [
                ...this.state.nmCompletedOrignalList_archive,
                ...response.data.data.completednm.nm_basic_info,
              ],
            });
          }
        }
        this.setState({ dataLoading: false });
      })
      .catch((error) => {
        this.setState({ dataLoading: false });
      });
  };

  // Start NM List
  // _getNMList = async (
  //   value = 1,
  //   type = "PROJECT",
  //   severity = null,
  //   serviceSelect = null,
  //   projectSelect = null,
  //   startDate = null,
  //   endDate = null,
  //   filtertype=0,
  //   overdue = null
  // ) => {  

  _getNMList = async (value, type = "PROJECT") => {
    this.setState({ moreDataLoading: true });
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("springToken");
    if (value > this.state.lastPagePending && value != 1) return;
    await this.setState({ nmPendingPageNo: value });
    let data;
    data = new FormData();

    if (type == "PROJECT") {
      if (this.state.project_id && this.state.project_id.length > 0) {
        this.state.project_id.forEach((item) => {
          data.append("projectIdList", item);
        });
      }
    }
    data.append("page", Math.ceil(value));
    data.append("auth_key", token);
    data.append("user_id", userId);
    data.append("startDate", this.props.start_date);
    data.append("endDate", this.props.end_date);
    data.append("type", 0);

    let URL = Url.nmModule.nmList;
    let headerType = "multipart/form-data";
    await axios
      .post(URL, data, {
        headers: {
          "Content-Type": headerType,
        },
        params: {
          auth_key: token,
          user_id: userId,
        }
      })
      .then((response) => {
        if (response.data.status == 200) {
          if (this.state.nmPendingl.length == 0 || value == 1) {
            this.setState({
              total_pendingnm: response.data.data.total_pendingnm,
              nmPendingl: response.data.data.pendingnm.nm_basic_info,
              nmPending2: response.data.data.pendingnm.nm_basic_info,
              nmPendingOrignalList: response.data.data.pendingnm.nm_basic_info,
              lastPagePending: Math.ceil(response.data.data.total_pendingnm / 10),
              // nmPendingPageNo: this.state.nmPendingPageNo + 1,
            });
          } else {
            this.setState({
              nmPendingl: [
                ...this.state.nmPendingl,
                ...response.data.data.pendingnm.nm_basic_info,
              ],
              // nmPendingPageNo: this.state.nmPendingPageNo + 1,
            });
            this.setState({
              nmPending2: [
                ...this.state.nmPending2,
                ...response.data.data.pendingnm.nm_basic_info,
              ],
            });
          }
        }
      })
      .catch((error) => { });
  };

  _getNMProgressList = async (value, type = "PROJECT") => {
    this.setState({ moreDataLoading: true });
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("springToken");
    if (value > this.state.lastPageProgress && value != 1) return;

    await this.setState({ nmProgressPageNo: value });
    let data;
    data = new FormData();

    // send project array in request only when project filter is applied
    if (type == "PROJECT") {
      if (this.state.project_id && this.state.project_id.length > 0) {
        this.state.project_id.forEach((item) => {
          data.append("projectIdList", item);
        });
      }
    }
    data.append("page", Math.ceil(value));
    data.append("auth_key", token);
    data.append("user_id", userId);
    data.append("startDate", this.props.start_date);
    data.append("endDate", this.props.end_date);
    data.append("type", 1);

    // await this._getNMList(
    //   pageNo ? pageNo : this.state.nmPendingFilterPageNo,
    //   "PROJECT",
    //   severity,
    //   serviceSelect,
    //   projectSelect,
    //   startDate,
    //   endDate,
    //   0
    // );


    let URL = Url.nmModule.nmList;
    let headerType = "multipart/form-data";
    await axios
      .post(URL, data, {
        headers: {
          "Content-Type": headerType,
        },
        params: {
          auth_key: token,
          user_id: userId,
        }
      })
      .then((response) => {
        if (response.data.status == 200) {
          if (this.state.nmProgressl.length == 0 || value == 1) {
            this.setState({
              total_inprogressnm: response.data.data.total_inprogressnm,
              nmProgressl: response.data.data.inprogressnm.nm_basic_info,
              nmProgress2: response.data.data.inprogressnm.nm_basic_info,
              nmProgressOrignalList:
                response.data.data.inprogressnm.nm_basic_info,
              lastPageProgress: Math.ceil(response.data.data.total_inprogressnm / 10),
            });
          } else {
            this.setState({
              nmProgressl: [
                ...this.state.nmProgressl,
                ...response.data.data.inprogressnm.nm_basic_info,
              ],
            });
            this.setState({
              nmProgress2: [
                ...this.state.nmProgress2,
                ...response.data.data.inprogressnm.nm_basic_info,
              ],
            });
            this.setState({
              nmProgressOrignalList: [
                ...this.state.nmProgressOrignalList,
                ...response.data.data.inprogressnm.nm_basic_info,
              ],
            });
          }
        }
        this.setState({ dataLoading: false });
      })
      .catch((error) => {
        this.setState({ dataLoading: false });
      });
  };

  _getNMCompletedList = async (value, type = "PROJECT") => {
    this.setState({ moreDataLoading: true });
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("springToken");
    if (value > this.state.lastPageCompleted && value != 1) return;

    await this.setState({ nmCompletedPageNo: value });
    let data;
    data = new FormData();

    if (type == "PROJECT") {
      if (this.state.project_id && this.state.project_id.length > 0) {
        this.state.project_id.forEach((item) => {
          data.append("projectIdList", item);
        });
      }
    }
    data.append("page", Math.ceil(value));
    data.append("auth_key", token);
    data.append("user_id", userId);
    data.append("startDate", this.props.start_date);
    data.append("endDate", this.props.end_date);
    data.append("type", 2);

    let URL = Url.nmModule.nmList;
    let headerType = "multipart/form-data";
    await axios
      .post(URL, data, {
        headers: {
          "Content-Type": headerType,
        },
        params: {
          auth_key: token,
          user_id: userId,
        }
      })
      .then((response) => {
        if (response.data.status == 200) {
          if (this.state.nmCompletedl.length == 0 || value == 1) {
            this.setState({
              total_completednm: response.data.data.total_completednm,
              nmCompletedl: response.data.data.completednm.nm_basic_info,

              nmCompleted2: response.data.data.completednm.nm_basic_info,
              nmCompletedOrignalList:
                response.data.data.completednm.nm_basic_info,
              lastPageCompleted: Math.ceil(response.data.data.total_completednm / 10),
            });
          } else {
            this.setState({
              nmCompletedl: [
                ...this.state.nmCompletedl,
                ...response.data.data.completednm.nm_basic_info,
              ],
            });
            this.setState({
              nmCompleted2: [
                ...this.state.nmCompleted2,
                ...response.data.data.completednm.nm_basic_info,
              ],
            });
            this.setState({
              nmCompletedOrignalList: [
                ...this.state.nmCompletedOrignalList,
                ...response.data.data.completednm.nm_basic_info,
              ],
            });
          }
        }
        this.setState({ dataLoading: false });
      })
      .catch((error) => {
        this.setState({ dataLoading: false });
      });
  };

  _getNMListExport = async () => {
    this.setState({ moreDataLoading: true });
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("token");
    let project_idString = "";
    if (this.state.project_id && this.state.project_id.length > 0) {
      project_idString = this.state.project_id.join(",");
    }
    await axios
      .post(
        Url.nmModule.nmlistexport,
        qs.stringify({
          auth_key: token,
          user_id: userId,
          "project_id": project_idString
        }),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      )
      .then((response) => {
        if (response.data.status == 200) {
          this.setState({
            nmPendingexport: response.data.data.pendingnm.pendinglist,
            nmProgressexport: response.data.data.inprogressnm.inprogresslist,
            nmCompletedexport: response.data.data.completednm.completedlist,
            dataLoading: false,
          });
          // console.log('pending', this.state.nmPending)
        }
        this.setState({ dataLoading: false });
      })
      .catch((error) => {
        this.setState({ dataLoading: false });
      });
  };

  _handleSearch = async (event) => {
    const val = event.target.value;

    if (val.trim() == "") {
      await this.setState({
        searchList2: val,
        searchBtnClicked2: true,
        nmPendingl: this.state.nmPendingOrignalList,
        nmCompletedl: this.state.nmCompletedOrignalList,
        nmProgressl: this.state.nmProgressOrignalList,
      });
    } else {
      await this.setState((prevState) => {
        let {
          searchList2,
          searchBtnClicked2,
          nmPendingl,
          nmProgressl,
          nmCompletedl,
          nmPending2,
          nmProgress2,
          nmCompleted2,
        } = prevState;
        searchList2 = val;
        searchBtnClicked2 = true;
        let searchTerm = searchList2.toLowerCase();

        nmPendingl = (nmPending2 || []).filter((data) => {
          if (!data) return false;
          return (
            data.activity?.toLowerCase().includes(searchTerm) ||
            data.type_of_act?.toLowerCase().includes(searchTerm) ||
            data.service?.toLowerCase().includes(searchTerm) ||
            data.project?.toLowerCase().includes(searchTerm) ||
            data.reported_by?.toLowerCase().includes(searchTerm)
          );
        });

        nmProgressl = (nmProgress2 || []).filter((data) => {
          if (!data) return false;
          return (
            data.activity?.toLowerCase().includes(searchTerm) ||
            data.type_of_act?.toLowerCase().includes(searchTerm) ||
            data.service?.toLowerCase().includes(searchTerm) ||
            data.project?.toLowerCase().includes(searchTerm) ||
            data.reported_by?.toLowerCase().includes(searchTerm)
          );
        });

        nmCompletedl = (nmCompleted2 || []).filter((data) => {
          if (!data) return false;
          return (
            data.activity?.toLowerCase().includes(searchTerm) ||
            data.type_of_act?.toLowerCase().includes(searchTerm) ||
            data.service?.toLowerCase().includes(searchTerm) ||
            data.project?.toLowerCase().includes(searchTerm) ||
            data.reported_by?.toLowerCase().includes(searchTerm)
          );
        });
        return {
          searchList2,
          searchBtnClicked2,
          nmPendingl,
          nmProgressl,
          nmCompletedl,
        };
      });
    }
  };

  nmPendingListFilter = async (
    severity,
    startDate,
    endDate,
    serviceSelect,
    projectSelect,
    pageNo,
    companySelect,
    categorySelect,
    softDeleteVal = 0
  ) => {
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("springToken") || localStorage.getItem("token");
    const currentPage = pageNo ? Math.ceil(pageNo) : this.state.nmPendingFilterPageNo;

    if (pageNo) {
      await this.setState({
        nmPendingFilterPageNo: pageNo,
        nmPendingl: [],
        pendingFilterCount: 0,
      });
    }

    const formData = new FormData();

    formData.append("auth_key", token);
    formData.append("user_id", userId);
    formData.append(
      "page_no",
      pageNo ? pageNo : this.state.nmPendingFilterPageNo
    );
    formData.append("severity", severity);
    formData.append("service_id", serviceSelect);
    formData.append("project_id", projectSelect);
    formData.append("start_date", startDate);
    formData.append("end_date", endDate);
    
    await axios.post(Url.nmModule.pendingfilter, formData, {
      params: {
        auth_key: token,
        user_id: userId,
      },
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((response) => {
        if (response.data.status === 200) {
          const list = response.data.data?.pendingnm?.nm_basic_info || [];
          const total = response.data.data?.total_pendingnm || list.length;

          if (softDeleteVal === 1) {
            this.setState({
              nmtrackListRefreshing: false,
              nmtrackListLoading: false,
              totalCount: total,
              lastPage: Math.ceil(total / 10),
              hasMore: currentPage <= Math.ceil(total / 10),
              moreDataLoading: false,
              nmPendingFilterPageNo: currentPage + 1,
              nmPendingl_archive:
                currentPage > 1
                  ? [...this.state.nmPendingl_archive, ...list]
                  : list,
              pendingFilterCount: total,
              total_pendingnm_archive: total,
              dataLoading: false,
            });
          } else {
            this.setState({
              nmtrackListRefreshing: false,
              nmtrackListLoading: false,
              totalCount: total,
              lastPage: Math.ceil(total / 10),
              hasMore: currentPage <= Math.ceil(total / 10),
              moreDataLoading: false,
              nmPendingFilterPageNo: currentPage + 1,
              nmPendingl:
                currentPage > 1
                  ? [...this.state.nmPendingl, ...list]
                  : list,
              pendingFilterCount: total,
              dataLoading: false,
            });
          }
        }
      })
      .catch((error) => {
        this.setState({ dataLoading: false });
      });
  };

  nmProgressListFilter = async (
    severity,
    startDate,
    endDate,
    serviceSelect,
    projectSelect,
    overdue,
    pageNo,
    companySelect,
    categorySelect,
    softDeleteVal = 0
  ) => {
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("springToken") || localStorage.getItem("token");
    const currentPage = pageNo ? Math.ceil(pageNo) : this.state.nmProgressFilterPageNo;

    if (pageNo) {
      await this.setState({
        nmProgressFilterPageNo: pageNo,
        nmProgressl: [],
        inprogressFilterCount: 0,
      });
    }

    const formData = new FormData();
    formData.append("auth_key", token);
    formData.append("user_id", userId);
    formData.append("page_no", pageNo ? pageNo : this.state.nmProgressFilterPageNo);
    formData.append("severity", severity);
    formData.append("service_id", serviceSelect);
    formData.append("project_id", projectSelect);
    formData.append("start_date", startDate);
    formData.append("end_date", endDate);
    formData.append("overdue", overdue || 0);
    
    await axios.post(
      Url.nmModule.inprogressfilter,
      formData,
      {
        params: {
          auth_key: token,
          user_id: userId,
        },
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
      .then((response) => {
        if (response.data.status === 200) {
          const list = response.data.data?.inprogressnm?.nm_basic_info || [];
          const total = response.data.data?.total_inprogressnm || list.length;

          if (softDeleteVal === 1) {
            this.setState({
              lastPage: Math.ceil(total / 10),
              hasMore: currentPage <= Math.ceil(total / 10),
              moreDataLoading: false,
              nmProgressFilterPageNo: currentPage + 1,
              nmProgressl_archive:
                currentPage > 1
                  ? [...this.state.nmProgressl_archive, ...list]
                  : list,
              inprogressFilterCount: total,
              total_inprogressnm_archive: total,
              dataLoading: false,
            });
          } else {
            this.setState({
              lastPage: Math.ceil(total / 10),
              hasMore: currentPage <= Math.ceil(total / 10),
              moreDataLoading: false,
              nmProgressFilterPageNo: currentPage + 1,
              nmProgressl:
                currentPage > 1
                  ? [...this.state.nmProgressl, ...list]
                  : list,
              inprogressFilterCount: total,
              dataLoading: false,
            });
          }
        }
      })
      .catch((error) => {
        this.setState({ dataLoading: false });
      });
  };

  nmCompletedListFilter = async (
    severity,
    startDate,
    endDate,
    serviceSelect,
    projectSelect,
    deviation,
    pageNo,
    companySelect,
    categorySelect,
    softDeleteVal = 0
  ) => {
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("springToken") || localStorage.getItem("token");
    const currentPage = pageNo ? Math.ceil(pageNo) : this.state.nmCompleteFilterPageNo;

    if (pageNo) {
      await this.setState({
        nmCompleteFilterPageNo: pageNo,
        nmCompletedl: [],
        completeFilterCount: 0,
      });
    }

    const formData = new FormData();
    formData.append("auth_key", token);
    formData.append("user_id", userId);
    formData.append(
      "page_no",
      pageNo ? pageNo : this.state.nmCompleteFilterPageNo
    );
    formData.append("severity", severity);
    formData.append("service_id", serviceSelect);
    formData.append("project_id", projectSelect);
    formData.append("start_date", startDate);
    formData.append("end_date", endDate);
    formData.append("overdue", deviation || 0);
    
    await axios.post(
      Url.nmModule.completedfilter,
      formData,
      {
        params: {
          auth_key: token,
          user_id: userId,
        },
        headers: {
          // Let axios set automatically
          "Content-Type": "multipart/form-data",
        },
      }
    )
      .then((response) => {
        if (response.data.status === 200) {
          const list = response.data.data?.completednm?.nm_basic_info || [];
          const total = response.data.data?.total_completednm || list.length;

          if (softDeleteVal === 1) {
            this.setState({
              lastPage: Math.ceil(total / 10),
              hasMore: currentPage <= Math.ceil(total / 10),
              moreDataLoading: false,
              nmCompleteFilterPageNo: currentPage + 1,
              nmCompletedl_archive:
                currentPage > 1
                  ? [...this.state.nmCompletedl_archive, ...list]
                  : list,
              completeFilterCount: total,
              total_completednm_archive: total,
              dataLoading: false,
            });
          } else {
            this.setState({
              lastPage: Math.ceil(total / 10),
              hasMore: currentPage <= Math.ceil(total / 10),
              moreDataLoading: false,
              nmCompleteFilterPageNo: currentPage + 1,
              nmCompletedl:
                currentPage > 1
                  ? [...this.state.nmCompletedl, ...list]
                  : list,
              completeFilterCount: total,
              dataLoading: false,
            });
          }
        }
      })
      .catch((error) => {
        this.setState({ dataLoading: false });
      });
  };

  _handlePendingSearch = async (event) => {
    const val = event.target.value;

    if (val.trim() === "") {
      await this.setState({
        searchList4: val,
        searchBtnClicked: true,
        nmPending2: this.state.nmPendingOrignalList,
      });
    } else {
      await this.setState((prevState) => {
        let { searchList4, searchBtnClicked, nmPendingl, nmPending2 } =
          prevState;
        searchList4 = val;
        searchBtnClicked = true;

        let searchTerm = searchList4.toLowerCase();

        nmPendingl = (nmPending2 || []).filter((data) => {
          if (!data) return false;
          return (
            data.activity?.toLowerCase().includes(searchTerm) ||
            data.type_of_act?.toLowerCase().includes(searchTerm) ||
            data.service?.toLowerCase().includes(searchTerm) ||
            data.project?.toLowerCase().includes(searchTerm) ||
            data.reported_by?.toLowerCase().includes(searchTerm)
          );
        });
        return { searchList4, searchBtnClicked, nmPendingl };
      });
    }
  };

  _handleProgressSearch = async (event) => {
    const val = event.target.value;

    if (val.trim() === "") {
      await this.setState({
        nmProgressl: this.state.nmProgressOrignalList,
        searchList5: val,
        searchBtnClicked2: true,
      });
    } else {
      await this.setState((prevState) => {
        let { nmProgressl, nmProgress2, searchList5, searchBtnClicked2 } =
          prevState;
        searchList5 = val;
        searchBtnClicked2 = true;
        let searchTerm = searchList5.toLowerCase();

        nmProgressl = (nmProgress2 || []).filter((data) => {
          if (!data) return false;
          return (
            data.activity?.toLowerCase().includes(searchTerm) ||
            data.type_of_act?.toLowerCase().includes(searchTerm) ||
            data.service?.toLowerCase().includes(searchTerm) ||
            data.project?.toLowerCase().includes(searchTerm) ||
            data.reported_by?.toLowerCase().includes(searchTerm)
          );
        });
        return { searchList5, searchBtnClicked2, nmProgressl };
      });
    }
  };

  _handleCompletedSearch = async (event) => {
    const val = event.target.value;

    if (val.trim() === "") {
      await this.setState({
        nmCompletedl: this.state.nmCompletedOrignalList,
        searchList6: val,
        searchBtnClicked2: true,
      });
    } else {
      await this.setState((prevState) => {
        let { nmCompletedl, nmCompleted2, searchList6, searchBtnClicked2 } =
          prevState;
        searchList6 = val;
        searchBtnClicked2 = true;
        let searchTerm = searchList6.toLowerCase();
        nmCompletedl = (nmCompleted2 || []).filter((data) => {
          if (!data) return false;
          return (
            data.activity?.toLowerCase().includes(searchTerm) ||
            data.type_of_act?.toLowerCase().includes(searchTerm) ||
            data.service?.toLowerCase().includes(searchTerm) ||
            data.project?.toLowerCase().includes(searchTerm) ||
            data.reported_by?.toLowerCase().includes(searchTerm)
          );
        });
        return { searchList6, searchBtnClicked2, nmCompletedl };
      });
    }
  };

  _getDefaultActiveTabKey = () => {
    let defaultTab = "dashboard";

    if (this.props.match.params.type === "tracker") {
      defaultTab = "tracker";
    } else if (this.props.match.params.type === "kanban") {
      defaultTab = "nmlist";
    }
    return defaultTab;
  };

  render() {
    const completedTrackerExport = this.state.trackerexport.filter(
      (item) => item.status == "Completed"
    );
    const progressTrackerExport = this.state.trackerexport.filter(
      (item) => item.status == "Inprogress"
    );
    const progress =
      this.state.inprogress_number != undefined && this.state.inprogress_number;
    const completed =
      this.state.completed_number != undefined && this.state.completed_number;
    const nmPending_archive =
      this.state.total_pendingnm_archive != undefined && this.state.total_pendingnm_archive;
    const nmPending =
      this.state.total_pendingnm != undefined && this.state.total_pendingnm;
    const nmProgress_archive =
      this.state.total_inprogressnm_archive != undefined &&
      this.state.total_inprogressnm_archive;
    const nmProgress =
      this.state.total_inprogressnm != undefined &&
      this.state.total_inprogressnm;
    const nmCompleted_archive =
      this.state.total_completednm_archive != undefined && this.state.total_completednm_archive;
    const nmCompleted =
      this.state.total_completednm != undefined && this.state.total_completednm;
    const totalCountracker =
      this.state.totalCountracker != undefined
        ? this.state.totalCountracker
        : 0;
    return (
      <NMModuleV2
        state={this.state}
        {...this.props}
        functionContent={this}
        capaProps={{
          progress_list: this.state.capaInprogressList,
          completed_list: this.state.capaCompletedList,
          progressListCount: this.state.capaProgressCount,
          completedListCount: this.state.capaCompletedCount,
          nmTrackerList: this.nmInprogressTrackerList,
          nmTrackerCompletedList: this.nmTrackerCompletedList,

          handleInputChange: this._handleInputChange,
          progressTrackerExport: progressTrackerExport,
          pageNumber: this.state.pageNumber,
          pageNumberCompleted: this.state.pageNumberCompleted,
          completedTrackerExport: completedTrackerExport,
          refetch: () => {
            window.location.reload();
          },
        }}
        listProps={{
          _getNMList: this._getNMList,
          _getNMProgressList: this._getNMProgressList,
          _getNMCompletedList: this._getNMCompletedList,
          nmPending: this.state.nmPendingl,
          nmCompleted: this.state.nmCompletedl,
          nmProgress: this.state.nmProgressl,
          ref: this.child,
          nmCompletedListFilter: this.nmCompletedListFilter,
          searchList4: this.state.searchList4,
          searchList5: this.state.searchList5,
          searchList6: this.state.searchList6,
          filterReset: this._handleFilterReset,
          nmPendingCount: nmPending,
          nmPendingPageNo: this.state.nmPendingPageNo,
          nmProgressCount: nmProgress,
          nmProgressPageNo: this.state.nmProgressPageNo,
          nmCompletedCount: nmCompleted,
          nmCompletedPageNo: this.state.nmCompletedPageNo,
          nmPendingListFilter: this.nmPendingListFilter,
          nmProgressListFilter: this.nmProgressListFilter,
          _handlePendingSearch: this._handlePendingSearch,
          _handleProgressSearch: this._handleProgressSearch,
          _handleCompletedSearch: this._handleCompletedSearch,
          pendingFilterCount: this.state.pendingFilterCount,
          inprogressFilterCount: this.state.inprogressFilterCount,
          completeFilterCount: this.state.completeFilterCount,
          state: this.state,
          handleInputChange: this._handleSearch,
        }}
        archiveProps={{
          _getNMList: this._getNMListArchive,
          _getNMProgressList: this._getNMProgressListArchive,
          _getNMCompletedList: this._getNMCompletedListArchive,
          nmPending: this.state.nmPendingl_archive,
          nmCompleted: this.state.nmCompletedl_archive,
          nmProgress: this.state.nmProgressl_archive,
          ref: this.child,
          nmCompletedListFilter: (sev, sd, ed, s, p, dev, pg, c, cat) =>
            this.nmCompletedListFilter(sev, sd, ed, s, p, dev, pg, c, cat, 1),
          searchList4: this.state.searchList4,
          searchList5: this.state.searchList5,
          searchList6: this.state.searchList6,
          filterReset: this._handleFilterReset,
          nmPendingCount: nmPending_archive,
          nmPendingPageNo: this.state.nmPendingPageNo,
          nmProgressCount: nmProgress_archive,
          nmProgressPageNo: this.state.nmProgressPageNo,
          nmCompletedCount: nmCompleted_archive,
          nmCompletedPageNo: this.state.nmCompletedPageNo,
          nmPendingListFilter: (sev, sd, ed, s, p, pg, c, cat) =>
            this.nmPendingListFilter(sev, sd, ed, s, p, pg, c, cat, 1),
          nmProgressListFilter: (sev, sd, ed, s, p, ov, pg, c, cat) =>
            this.nmProgressListFilter(sev, sd, ed, s, p, ov, pg, c, cat, 1),
          _handlePendingSearch: this._handlePendingSearch,
          _handleProgressSearch: this._handleProgressSearch,
          _handleCompletedSearch: this._handleCompletedSearch,
          pendingFilterCount: this.state.pendingFilterCount,
          inprogressFilterCount: this.state.inprogressFilterCount,
          completeFilterCount: this.state.completeFilterCount,
          state: this.state,
          handleInputChange: this._handleSearch,
        }}
      />
    );
    return (
      <NMModuleV2
        state={this.state}
        {...this.props}
        functionContent={this}
        capaProps={{
          progress_list: this.state.capaInprogressList,
          completed_list: this.state.capaCompletedList,
          progressListCount: this.state.capaProgressCount,
          completedListCount: this.state.capaCompletedCount,
          nmTrackerList: this.nmInprogressTrackerList,
          nmTrackerCompletedList: this.nmTrackerCompletedList,

          handleInputChange: this._handleInputChange,
          progressTrackerExport: progressTrackerExport,
          pageNumber: this.state.pageNumber,
          completedTrackerExport: completedTrackerExport,
          refetch: () => {
            window.location.reload();
          },
        }}
        listProps={{
          _getNMList: this._getNMList,
          _getNMProgressList: this._getNMProgressList,
          _getNMCompletedList: this._getNMCompletedList,
          nmPending: this.state.nmPendingl,
          nmCompleted: this.state.nmCompletedl,
          nmProgress: this.state.nmProgressl,
          ref: this.child,
          nmCompletedListFilter: this.nmCompletedListFilter,
          searchList4: this.state.searchList4,
          searchList5: this.state.searchList5,
          searchList6: this.state.searchList6,
          filterReset: this._handleFilterReset,
          nmPendingCount: nmPending,
          nmProgressCount: nmProgress,
          nmCompletedCount: nmCompleted,
          nmPendingListFilter: this.nmPendingListFilter,
          nmProgressListFilter: this.nmProgressListFilter,
          _handlePendingSearch: this._handlePendingSearch,
          _handleProgressSearch: this._handleProgressSearch,
          _handleCompletedSearch: this._handleCompletedSearch,
          pendingFilterCount: this.state.pendingFilterCount,
          inprogressFilterCount: this.state.inprogressFilterCount,
          completeFilterCount: this.state.completeFilterCount,
          state: this.state,
          handleInputChange: this._handleSearch,
        }}
      />
    );

  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(NmDashboard)
);
